import React from 'react'

export default function PasswordInput({placeholder}) {
  const [showPassword, setshowPassword] = React.useState(false);

    return (
        <>
             <input
                    type={showPassword ? "text" : "password"}
                    className={`form__input has-icon has-left-icon circle `}
                   placeholder={placeholder}
                    
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/img/lock.svg`}
                    alt="cobon back"
                    className="form__icon"
                  />
                  {showPassword ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/img/eye_2.svg`}
                      alt="cobon back"
                      onClick={() => setshowPassword(!showPassword)}
                      className="form__icon--left"
                    />
                  ) : (
                    <img
                      src={`${process.env.PUBLIC_URL}/img/eye.svg`}
                      alt="cobon back"
                      onClick={() => setshowPassword(!showPassword)}
                      className="form__icon--left"
                    />
                  )}
        </>
    )
}
